
import Vue, { PropType } from 'vue'
import { BulkSensorsTransactionRow } from '@/models'
import moment from 'moment'

export default Vue.extend({
  name: 'SensorListItem',

  props: {
    row: Object as PropType<BulkSensorsTransactionRow>,
    no: Number as PropType<number>
  },

  computed: {
    statusTextClass(): string {
      return this.row?.status !== '登録可能' ? 'red' : ''
    },
  }
})
